import { PayrollShiftListItemDto } from '@clh/api-client';

export const isAwaitingTimeSubmission = (shift: PayrollShiftListItemDto) =>
    !shift.minutesWorked &&
    !shift.onCallShift?.minutesWorked &&
    !shift.didNotWork;

export type ShiftCountFilter = 'awaiting' | 'active';

export const filterShifts = (
    shifts: PayrollShiftListItemDto[],
    filter: ShiftCountFilter | null
) => (filter === 'awaiting' ? shifts.filter(isAwaitingTimeSubmission) : shifts);
